"use client"

import { ProductPageAccordion } from '@/components/molecules';
import { useTranslate } from '@tolgee/react';

export const ProductDetailsShipping = () => {
  const { t } = useTranslate();
  return (
    <ProductPageAccordion
      heading={t("product_details.shipping_returns_heading")}
      defaultOpen={false}
    >
      <div className='product-details'>
        <ul>
          <li>
            {t("product_details.shipping_returns_description_1")}
          </li>
          <li>
            {t("product_details.shipping_returns_description_2")}
          </li>
        </ul>
      </div>
    </ProductPageAccordion>
  );
};
